/**
 * A Highcharts plugin for exporting data from a rendered chart as CSV, XLS or HTML table
 *
 * Author:   Torstein Honsi
 * Licence:  MIT
 * Version:  1.3.6
 *
 * Modified by Keepcon to fix the exporting of hierarchical charts (2015-10)
 */
/*global Highcharts, window, document, Blob */
(function (Highcharts) {

    'use strict';

    var each = Highcharts.each,
        downloadAttrSupported = document.createElement('a').download !== undefined;

    Highcharts.setOptions({
        lang: {
            downloadCSV: 'Download CSV',
            downloadXLSX: 'Download XLSX'
        }
    });


    /**
     * Get the data rows as a two dimensional array
     */
    Highcharts.Chart.prototype.getDataRows = function () {

        var options = (this.options.exporting || {}).csv || {},
            xAxis = this.xAxis[0],
            rows = {},
            rowArr = [],
            dataRows,
            names = [],
            i,
            x,
            numberOfSeries = this.series.length,
            isHierarchical = (numberOfSeries > 1 && !this.series[0].xAxis) || (this.options && this.options.isHierarchical),
            isBarHierarchyNavigation = this.options.isBarHierarchyNavigation,
            isHeatmap = this.options.isHeatmap,
            allFilteredSeries = [],

            // Options
            dateFormat = options.dateFormat || '%Y-%m-%d %H:%M:%S',
            columnHeaderFormatter = options.columnHeaderFormatter || function (series, key, keyLength) {
                return series.name + (keyLength > 1 ? ' ('+ key + ')' : '');
            };

        if (isHierarchical && !isHeatmap) { // categories with 0 must be excluded to determine parents
            allFilteredSeries = this.series.map(function(series) {
                var keys = series.options.keys,
                    pointArrayMap = keys || series.pointArrayMap || ['y'],
                    filteredSeries = _.clone(series);

                filteredSeries.points = series.points.filter(function(point) { return (point[pointArrayMap[0]] > 0) });
                return filteredSeries;
            });
        } else {
            allFilteredSeries = this.series; // categories with 0 are conserved
        }

        var seriesLengths = allFilteredSeries.map(function(series) { return series.points.length });

        // Loop the series and index values
        i = 0;
        each(allFilteredSeries, function (series, seriesIndex, allSeries) {
            var keys = series.options.keys,
                pointArrayMap = keys || series.pointArrayMap || ['y'],
                valueCount = pointArrayMap.length,
                requireSorting = series.requireSorting,
                j,
                currentParentIndex = 0,
                currentParent,
                currentParentValue,
                acumValues = 0,
                nextSeries = allSeries[seriesIndex+1];

            if (series.options.includeInCSVExport !== false && series.visible !== false) { // #55
                j = 0;
                while (j < valueCount) { // valueCount is 1 if both 'keys' and 'series.pointArrayMap' are undefined
                    names.push(columnHeaderFormatter(series, pointArrayMap[j], pointArrayMap.length));
                    j = j + 1;
                }

                var padding = 0;
                if (isHierarchical) {
                    padding = seriesLengths.slice(seriesIndex + 1).reduce(function(acumLength, currentLength) {
                        return acumLength + currentLength;
                    }, 0);
                }
                each(series.points, function (point, pIdx) {
                    var key = requireSorting ? point.x : pIdx, // row number
                        keyWithPadding = key + padding;

                    j = 0;

                    rows[keyWithPadding] = rows[keyWithPadding] || [];

                    rows[keyWithPadding].x = point.x + padding; // row number

                    if (isBarHierarchyNavigation) {
                        rows[keyWithPadding].level = 1;
                    } else {
                        rows[keyWithPadding].level = numberOfSeries - seriesIndex;
                    }

                    // Pies, funnels etc. use point name in X row
                    if (!series.xAxis) {
                        rows[keyWithPadding].name = point.name;

                        // Add the parent name in hierarchical charts
                        if (isHierarchical) {
                            if (seriesIndex == numberOfSeries - 1) {
                                rows[keyWithPadding].parent = '-';
                            } else {
                                currentParent = nextSeries.points[currentParentIndex];
                                // Hierarchical charts with more than one value per point are not supported
                                currentParentValue = currentParent[pointArrayMap[0]];
                                acumValues += point[pointArrayMap[0]];
                                if (acumValues > currentParentValue) {
                                    currentParentIndex ++;
                                    acumValues = point[pointArrayMap[0]];
                                }

                                rows[keyWithPadding].parent = nextSeries.points[currentParentIndex].name;
                                // Eliminate percentage in top level categories
                                rows[keyWithPadding].parent = rows[keyWithPadding].parent.replace(/(.*?) \((.*?)%\)$/g, '$1');
                            }
                        }
                    } else if (isBarHierarchyNavigation && point.name) {
                        rows[keyWithPadding].name = point.name.replace(/(.*?) \((.*?)%\)$/g, '$1');
                    }

                    if (isBarHierarchyNavigation) {
                        while (j < valueCount) {
                            rows[keyWithPadding][0 + j] = point[pointArrayMap[j]];
                            j = j + 1;
                        }
                    } else {
                        while (j < valueCount) {
                            rows[keyWithPadding][i + j] = point[pointArrayMap[j]];
                            j = j + 1;
                        }
                    }

                });
                i = i + j; // series number? j is 1 if valueCount is 1
            }
        });

        // Make a sortable array
        for (x in rows) {
            if (rows.hasOwnProperty(x)) {
                if (rows[x].name || xAxis.isDatetimeAxis || xAxis.categories || isBarHierarchyNavigation) { // exclude repeated data caused by unbalanced tree
                    rowArr.push(rows[x]);
                }
            }
        }
        // Sort it by X values and by level if hierarchical
        if (isHierarchical) {
            rowArr.sort(function (a, b) {
                return a.level - b.level || a.x - b.x;
            });
        } else {
            rowArr.sort(function (a, b) {
                return 100*(a.x - b.x) + ((a[0] || 0) - (b[0] || 0));
            });
        }

        // Add header row
        if (isHierarchical) {
            if (isBarHierarchyNavigation) {
                dataRows = [[xAxis.isDatetimeAxis ? 'DateTime' : 'Category'].concat(['Count'])];
            } else {
                dataRows = [[xAxis.isDatetimeAxis ? 'DateTime' : 'Category'].concat(['Count', 'Level', 'Parent'])];
            }
        } else {
            dataRows = [[xAxis.isDatetimeAxis ? 'DateTime' : 'Category'].concat(names)];
        }

        // Add data rows
        each(rowArr, function (row) {

            var category = row.name;
            if (!category) {
                if (xAxis.isDatetimeAxis) {
                    category = Highcharts.dateFormat(dateFormat, row.x);
                } else if (xAxis.categories) {
                    category = Highcharts.pick(xAxis.names[row.x], xAxis.categories[row.x], row.x)
                } else {
                    category = row.x;
                }
            }

            // Eliminate percentage in top level categories
            if (isHierarchical) {
                category = category.replace(/(.*?) \((.*?)%\)$/g, '$1');
            }

            // Add the X/date/category
            row.unshift(category); // add the category as the first column of csv/xls
            if (isHierarchical) {
                row.push(row.level); // add the nesting level as the to-be-second column
                if (row.level > 1) {
                    row.push(row.parent); // add the name of the parent category as the to-be-third column
                } else {
                    row.push('-');
                }
                row = [row[0]].concat(row.slice(-3)); // trim the row to only include the category, the count, the level and the parent (discard undefined values, cells skipped because of the padding)
            }
            if (isBarHierarchyNavigation) {
                // Remove Parent and level
                row.pop();
                row.pop();
            }
            dataRows.push(row);
        });

        return dataRows;
    };

    /**
     * Get a CSV string
     */
    Highcharts.Chart.prototype.getCSV = function (useLocalDecimalPoint) {
        var csv = '',
            rows = this.getDataRows(),
            options = (this.options.exporting || {}).csv || {},
            itemDelimiter = options.itemDelimiter || ',', // use ';' for direct import to Excel
            lineDelimiter = options.lineDelimiter || '\n'; // '\n' isn't working with the js csv data extraction

        // Transform the rows to CSV
        each(rows, function (row, i) {
            var val = '',
                j = row.length,
                n = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.';
            while (j--) {
                val = row[j];
                if (typeof val === "string") {
                    val = '"' + val + '"';
                }
                if (typeof val === 'number') {
                    if (n === ',') {
                        val = val.toString().replace(".", ",");
                    }
                }
                row[j] = val;
            }
            // Add the values
            csv += row.join(itemDelimiter);

            // Add the line delimiter
            if (i < rows.length - 1) {
                csv += lineDelimiter;
            }
        });
        return csv;
    };

    /**
     * Build a HTML table with the data
     */
    Highcharts.Chart.prototype.getTable = function (useLocalDecimalPoint) {
        var html = '<table>',
            rows = this.getDataRows();

        // Transform the rows to HTML
        each(rows, function (row, i) {
            var tag = i ? 'td' : 'th',
                val,
                j,
                n = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.';

            html += '<tr>';
            for (j = 0; j < row.length; j = j + 1) {
                val = row[j];
                // Add the cell
                if (typeof val === 'number') {
                    if (n === ',') {
                        html += '<' + tag + (typeof val === 'number' ? ' class="number"' : '') + '>' + val.toString().replace(".", ",") + '</' + tag + '>';
                    } else {
                        html += '<' + tag + (typeof val === 'number' ? ' class="number"' : '') + '>' + val.toString() + '</' + tag + '>';
                    }
                } else {
                    html += '<' + tag + '>' + val + '</' + tag + '>';
                }
            }

            html += '</tr>';
        });
        html += '</table>';
        return html;
    };

    function getContent(chart, href, extension, content, MIME) {
        var a,
            blobObject,
            name,
            options = (chart.options.exporting || {}).csv || {},
            url = options.url || 'https://www.highcharts.com/studies/csv-export/download.php';

        name = chartName(chart);

        // Download attribute supported
        if (downloadAttrSupported) {
            a = document.createElement('a');
            a.href = href;
            a.target      = '_blank';
            a.download    = name + '.' + extension;
            document.body.appendChild(a);
            a.click();
            a.remove();

        } else if (window.Blob && window.navigator.msSaveOrOpenBlob) {
            // Falls to msSaveOrOpenBlob if download attribute is not supported
            blobObject = new Blob([content]);
            window.navigator.msSaveOrOpenBlob(blobObject, name + '.' + extension);

        } else {
            // Fall back to server side handling
            Highcharts.post(url, {
                data: content,
                type: MIME,
                extension: extension
            });
        }
    }

    /**
     * Call this on click of 'Download CSV' button
     */
    Highcharts.Chart.prototype.downloadCSV = function () {
        var csv = this.getCSV(true);
        getContent(
            this,
            'data:text/csv,' + csv.replace(/\n/g, '%0A'),
            'csv',
            csv,
            'text/csv'
        );
    };

    /**
     * Call this on click of 'Download XLS' button
     */
    Highcharts.Chart.prototype.downloadXLS = function () {
        var uri = 'data:application/vnd.ms-excel;base64,',
            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="https://www.w3.org/TR/REC-html40">' +
                '<head><!--[if gte mso 9]><?xml version="1.0" encoding="UTF-8" standalone="yes"?><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>' +
                '<x:Name>Ark1</x:Name>' +
                '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' +
                '<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0";}</style>' +
                '<meta name=ProgId content=Excel.Sheet/>' +
                '<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>' +
                '</head><body>' +
                this.getTable(true) +
                '</body></html>',
            base64 = function (s) {
                return window.btoa(unescape(encodeURIComponent(s))); // #50
            };
        getContent(
            this,
            uri + base64(template),
            'xls',
            template,
            'application/vnd.ms-excel'
        );
    };

    function chartName(chart) {
        let name;
        try {
            if (chart.options.exporting && chart.options.exporting.filename) {
                name = chart.options.exporting.filename;
            } else if (chart.title && chart.title.textStr) {
                name = chart.title.textStr.replace(/ /g, '-').toLowerCase();
            } else {
                name = 'chart';
            }
        } catch {
            name = 'chart';
        }
        return name;
    }

    Highcharts.Chart.prototype.downloadXLSX = function () {
        var rows = this.getDataRows(true);

        var xlsxRows = rows.map(function (row) {
            return row.map(function (column) {
                return {
                    type: typeof column === 'number' ? 'number' : 'string',
                    value: column
                };
            });
        });

        var name = chartName(this);

        window.zipcelx({
            filename: name,
            sheet: {
                data: xlsxRows
            }
        });
    };


    // Add "Download CSV" to the exporting menu. Use download attribute if supported, else
    // run a simple PHP script that returns a file. The source code for the PHP script can be viewed at
    // https://raw.github.com/highslide-software/highcharts.com/master/studies/csv-export/csv.php
    if (Highcharts.getOptions().exporting) {
        Highcharts.getOptions().exporting.buttons.contextButton.menuItems.push({
            textKey: 'downloadCSV',
            onclick: function () { this.downloadCSV(); }
        }, {
            textKey: 'downloadXLSX',
            onclick: function () { this.downloadXLSX(); }
        });
    }

}(Highcharts));
